import InputMultiSelect from './InputMultiSelect';
export default InputMultiSelect;
